import { Group, Heading, Paper, useToggle } from '@ingeniorforeningen/figurine-core';
import { stripText } from '../../helpers/textsHelpers';
import { HistoryButton } from './HistoryButton';
import { Table } from './Table';
import { UiCase } from '../../types';

type TableListProps = {
  loading: boolean;
  openCases: UiCase[] | null;
  closedCases: UiCase[] | null;
  noCasesText?: string;
  closedCasesText?: string;
  language: string;
  showHistoryText?: string;
  hideHistoryText?: string;
};

export const TableList = ({
  loading,
  openCases,
  closedCases,
  noCasesText,
  closedCasesText,
  language,
  showHistoryText,
  hideHistoryText,
}: TableListProps) => {
  const [hideHistory, toggle] = useToggle([false, true]);
  const closedCasesExists = closedCases && closedCases.length > 0;
  const openCasesExists = openCases && openCases.length > 0;

  return (
    <Paper>
      <Group px="md" py="xl">
        <Table
          cypress="openCases"
          cases={openCasesExists ? openCases : null}
          loading={loading}
          noCasesText={noCasesText}
          language={language}
        />
        {hideHistory && closedCasesExists && (
          <>
            <Heading text={stripText(closedCasesText)} type="h2" mt="xl" mb="sm" />
            <Table
              cypress="closedCases"
              cases={closedCases}
              loading={loading}
              language={language}
            />
          </>
        )}
        {closedCasesExists && !loading && (
          <HistoryButton
            onClick={toggle}
            variant={hideHistory ? 'hideHistory' : 'showHistory'}
            showHistoryText={showHistoryText}
            hideHistoryText={hideHistoryText}
          />
        )}
      </Group>
    </Paper>
  );
};
